
export const formatTextWithLineBreaks = (text, maxLength = 15) => {
    if(!text || text.length <= maxLength) return {text, lines: 0};

    if(text.length <= maxLength) {
        return {
            text: text.trim(),
            lines: 1
        };
    }

    const words = text.split(' ');
    let result = '';
    let currentLine = '';
    let lines = 0;

    words.forEach(word =>{
        if((currentLine + word).trim().length <= maxLength) {
            currentLine = (currentLine + ' ' + word).trim();
        }else{
            if(result) result += '\n';
            result += currentLine;
            currentLine = word;
            lines++;
        }
    });

    if(currentLine) {
        if(result) result += '\n';
        result += currentLine;
        lines++;
    }
    return {
        text: result,
        lines
    };

}